import {useEffect} from 'react';

export function useEditorPrefetchVectorMobileModules(): void {
  useEffect((): void => {
    void prefetchVectorModules();
  }, []);

  const prefetchVectorModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-vector-fill-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-vector-border-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-shadow-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-shadow-panel');
  };
}
